import { Injectable, inject } from '@angular/core';
import { AppointmentRequestQueryConnectorService } from '@warema/shared/connector-services';
import { AppointmentRequestQuery, AppointmentRequestQueryPost, StorageConstants } from '@warema/shared/models';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AppointmentRequestQueryService {
    private readonly _connectorService = inject(AppointmentRequestQueryConnectorService);

    public storeAppointmentRequestQueryToLocalStorage(requestQuery: AppointmentRequestQueryPost): void {
        localStorage.setItem(StorageConstants.APPOINTMENT_REQUEST_QUERY, JSON.stringify(requestQuery));
    }

    public saveAppointmentRequestQueryFromLocalStorageToDb(): Observable<AppointmentRequestQuery> {
        const storageQuery = localStorage.getItem(StorageConstants.APPOINTMENT_REQUEST_QUERY);

        if (!storageQuery) {
            return of();
        }
        const appointmentQuery = JSON.parse(storageQuery) as AppointmentRequestQueryPost;
        localStorage.removeItem(StorageConstants.APPOINTMENT_REQUEST_QUERY);

        return this._connectorService.saveAppointmentQuery(appointmentQuery);
    }
}
